import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <section id="pricing" className="py-20 md:py-32 bg-[#F7F8FA]">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white text-[#C8A24A] text-xs font-semibold tracking-wider uppercase mb-5 border border-[#C8A24A]/20">
              {t('trafficMaster.pricingTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111111] leading-tight">
              {t('trafficMaster.pricingTitle')}
            </h2>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <div className="bg-white rounded-3xl border border-gray-100 shadow-[0_20px_60px_rgba(0,0,0,0.06)] overflow-hidden">
            <div className="relative">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#E53935] via-[#C8A24A] to-[#E53935]"></div>

              <div className="p-10 md:p-12 text-center">
                <div className="mb-8">
                  <div className="text-gray-500 text-sm font-medium mb-2">
                    {t('trafficMaster.pricingWeekly')}
                  </div>
                  <div className="font-heading text-5xl md:text-6xl font-extrabold text-[#E53935] mb-2">
                    {t('trafficMaster.pricingWeeklyAmount')}
                  </div>
                  <div className="flex items-center justify-center gap-2 text-gray-500 text-sm">
                    <span className="w-8 h-[1px] bg-gray-300"></span>
                    <span>{t('trafficMaster.pricingEquivalent')}</span>
                    <span className="w-8 h-[1px] bg-gray-300"></span>
                  </div>
                </div>

                <div className="mb-8">
                  <div className="font-heading text-3xl md:text-4xl font-bold text-[#111111] mb-1">
                    {t('trafficMaster.pricingMonthly')}
                  </div>
                  <div className="text-[#E53935] font-heading text-2xl font-semibold">
                    {t('trafficMaster.pricingMonthlyUsd')}
                  </div>
                </div>

                <div className="mb-10">
                  <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#C8A24A]/5 border border-[#C8A24A]/20">
                    <i className="ri-information-line text-[#C8A24A] text-sm"></i>
                    <span className="text-[#111111] text-sm font-medium">
                      {t('trafficMaster.pricingHighlight')}
                    </span>
                  </div>
                </div>

                <a
                  href="#final-cta"
                  className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-[#E53935] text-white text-base font-semibold hover:bg-[#B71C1C] transition-all duration-300 whitespace-nowrap shadow-[0_4px_24px_rgba(229,57,53,0.35)] hover:shadow-[0_8px_36px_rgba(229,57,53,0.5)] hover:-translate-y-0.5 cursor-pointer"
                >
                  {t('trafficMaster.pricingCta')}
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}